import DataAccess from "../DataAccessStrategy";

export default class MeioPagamento extends DataAccess {
  constructor() {
    super("MeioPagamento", {
      id: Number,
      shouldSync: Boolean,
      updatedDate: Date,
      nome: String,
    });
  }
}
